import React, {useState} from 'react'
import { useTranslation } from 'react-i18next';
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AccessLogModalApp = () => {
    const { t } = useTranslation();
    const [criteria, setCriteria] = useState();
    const moduleId = `${MODELS.EQUIPMENT_ACCESS_LOG}`;
    const option = `${TABLES.EQUIPMENT_ACCESS_LOG}`;
    const [search, setSearch] = useState(false);
    const [displayModal, setDisplayModal] = useState('');

    return {
        t,
        moduleId,
        criteria,
        option,
        setCriteria,
        search,
        displayModal,
        setDisplayModal
    };
}

export default AccessLogModalApp
